// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"abc265a4","93":"9e722ee1","177":"bf12c4b6","217":"e9ceb583","364":"3954caf9","371":"10f58627","474":"bba82163","482":"6b7c0af5","541":"c4d28323","640":"053b5c1a","758":"f3177d05","789":"dc266460","796":"b3f00f53","816":"2f7481ed","839":"9b0d6737","928":"98e881d8"}[chunkId] + ".chunk.js";
};